import React from 'react';

function Optional(props) {
  const hasOptional = props.hasOptional;
  if (hasOptional) {
    return (
      <span className="slds-text-heading_medium page-block-header-optional">
        (Optional)
      </span>
    );
  }
  return null;
}

class PageBlockHeader extends React.Component {
  render() {
    return (
      <div
        className={
          'page-block-header' +
          (this.props.hasBorder ? ' page-block-border' : '')
        }
      >
        <span
          className={
            'slds-text-heading_large page-block-header-title' +
            (this.props.addtl ? ' margin-l' : '')
          }
        >
          {this.props.title}
        </span>
        <span className="slds-text-heading_large page-block-header-additional">
          {this.props.addtl}
        </span>
        <div
          className={
            'slds-text-title_caps slds-p-top_x-small' +
            (this.props.addtl ? ' margin-l' : '')
          }
        >
          {this.props.subtitle}
        </div>
        <Optional hasOptional={this.props.hasOptional} />
      </div>
    );
  }
}

export default PageBlockHeader;
